import React from 'react';
import { Redirect } from 'react-router-dom';

import { GAMES, PRACTICES } from '../../../config/constants';
import { useRouter } from '../../../helpers/customHooks';
import { isCC, isNCAAAllSports } from '../../../helpers/helpers';
import { useDataPlayersState, useUserState } from '../../../store/hooks';
import { PlayerRoutes } from '../types';

export default () => {
  const user = useUserState();
  const { match, location } = useRouter<PlayerRoutes>();
  const { dataPlayer } = useDataPlayersState(match.params.playerId);
  
  const event = (isCC(user) || isNCAAAllSports(user)) ? PRACTICES : (dataPlayer && dataPlayer.meta && dataPlayer.meta.teamId === user.teamId ? PRACTICES : GAMES);
  return(
    <Redirect 
      to={{ 
        pathname: `/player/${match.params.playerId}/${event}`, 
        search: location.search, 
        state: location.state 
      }} 
    />);
};
